(function () {
  'use strict';

  // ── Constants ────────────────────────────────────────────────────────────

  const CS_STEPS = ['scanned', 'designing', 'prototyping', 'awaiting', 'testing'];

  const DIFFICULTY_TEXT = {
    1: 'Easy to fit — basic tools, zero drama.',
    2: 'Simple to fit — no head-scratching needed.',
    3: 'Fiddly to fit — tighter access, steady hands.',
    4: 'Harder to fit — set aside an hour (or two).',
    5: 'Expert to fit — not a first-timer job.',
  };

  const FITMENT_CTA = {
    1: "Dead easy, but if you'd rather we handle it — we're here.",
    2: "Straightforward, but you can always book it in with us.",
    3: "Getting fiddly — no shame in letting us sort it.",
    4: "This one's a job — book a fitment and save yourself the grief.",
    5: "Seriously, just book this one in. Trust.",
  };

  // ── Helpers ──────────────────────────────────────────────────────────────

  function fi(name) {
    return `<i data-feather="${name}"></i>`;
  }

  function kickFeather() {
    if (window.feather) window.feather.replace();
  }

  function csActiveIndex(status) {
    const idx = CS_STEPS.indexOf(status);
    return idx === -1 ? 0 : idx + 1;
  }

  // ── Coming soon tracker ──────────────────────────────────────────────────

  function renderTrackerStep(label, stepNum, activeIndex, description) {
    const isComplete = activeIndex > stepNum;
    const isActive   = activeIndex === stepNum;
    const stateClass = isComplete ? 'is-complete' : isActive ? 'is-active' : 'is-upcoming';
    const showDesc   = activeIndex >= stepNum;
    const mutedClass = isComplete ? 'is-muted' : '';

    return `
      <div class="tracker-step ${stateClass}">
        <div class="tracker-step__marker"><span class="tracker-step__dot"></span></div>
        <div class="tracker-step__content">
          <div class="tracker-step__title-row">
            <h4 class="tracker-step__title">${label}</h4>
            ${isActive ? '<span class="tracker-step__live">Live</span>' : ''}
          </div>
          ${showDesc ? `<div class="tracker-step__description ${mutedClass}">${description}</div>` : ''}
        </div>
      </div>`;
  }

  function renderComingSoon(v, DATA) {
    const variantLabel = DATA.variantCount > 1 ? v.title : '';
    const productTitle = DATA.productTitle;
    const activeIndex  = csActiveIndex(v.comingSoonStatus);
    const signup       = v.comingSoonSignup;

    if (v.helpWanted) {
      return `
        <div class="coming-soon-note">
          <h3>Not available yet but...</h3>
          <p class="small">
            We're itching to make this bracket, we just need a bike to scan/look at first.
            Local to Kent/London and fancy helping out?
            <a class="underline" target="_blank"
              href="mailto:help@flipndip.co.uk?bcc=cad@flipndip.co.uk&subject=${encodeURIComponent(productTitle + ' ' + variantLabel + ' Scan')}&body=${encodeURIComponent('Hey,\n\nI have a ' + productTitle + ' ' + variantLabel + ' and I am local, when would you like to scan it?\n\nThanks,\n')}">
              Drop us a message
            </a>
            <br>
            <span class="small" style="font-style:italic;">(FYI it's a free bracket for your troubles)</span>
          </p>
        </div>`;
    }

    if (activeIndex > 0) {
      const steps = [
        ['Scanned',     1, "We've 3D scanned the bike and have what we need to start development."],
        ['Designing',   2, "We're actively designing the bracket. This usually takes around 1–3 weeks depending on complexity."],
        ['Prototyping', 3, "We've printed a prototype and we're testing it before sending it to production. This usually takes around a week, as we need the bike back in."],
        ['Production',  4, "The parts are in production and we're waiting for them to land. This normally takes around 2–3 weeks to receive the parts."],
        ['Testing',     5, "We've got the production parts and we're testing everything before release. This usually takes around a week, as we need the bike back in."],
      ];

      return `
        <div class="coming-soon-note">
          <div class="coming-soon-tracker">
            <div class="coming-soon-tracker__header">
              <h3>We're working on this one</h3>
              <p class="small">This bracket is currently in development. Here's where it's at.</p>
            </div>
            <div class="coming-soon-tracker__timeline">
              ${steps.map(([label, num, desc]) => renderTrackerStep(label, num, activeIndex, desc)).join('')}
            </div>
            ${signup ? `
              <div class="coming-soon-tracker__cta">
                <p class="small">Want this bracket when it lands? Leave your number and be first in line for updates.</p>
                <a href="${signup}" class="btn" target="_blank">Get updates</a>
              </div>` : ''}
          </div>
        </div>`;
    }

    return `
      <div class="coming-soon-note">
        <h3>We're working on this one!</h3>
        <p class="small">
          It's not live yet — we're scanning, designing, and testing. Give us around 2–5 weeks.
          ${signup ? `<br><br>Want this bracket when it lands? Leave your number and be first in line for updates.<br>
            <a href="${signup}" class="btn" target="_blank">Get updates</a>` : ''}
        </p>
      </div>`;
  }

  // ── Fitment service block ─────────────────────────────────────────────────

   function renderFitmentService(rating) {
    const el = document.querySelector('.fitment-service-block');
    if (!el) return;

    const hasRating = rating && rating >= 1;

    const wrenches = Array.from({ length: 5 }, (_, i) =>
      `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tool fitment-difficulty-icon${i < rating ? ' is-active active' : ''}" aria-hidden="true"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>`
    ).join('');

    const difficultyRow = hasRating ? `
      <div class="fitment-difficulty mb10" aria-label="Fitment difficulty ${rating} of 5">
        ${wrenches}
        <span class="fitment-difficulty-text">${DIFFICULTY_TEXT[rating]}</span>
      </div>` : '';

    const ctaText = hasRating
      ? FITMENT_CTA[rating]
      : "Want us to fit your bracket? Book in a fitment at the studio.";

    el.innerHTML = `
      <div class="product__text__container mt--first-child-0">
        <div class="section-text-with-icons-type-1__block mt--first-child-0 mb--last-child-0">
          ${difficultyRow}
          <h6 class="mt0"><a href="/products/bracket-fitment-service" class="clear-underline heading-color-block-hover animation-underline">Want us to fit it?</a></h6>
          <div class="mt10 body2 section__richtext__editor">
            <p>${ctaText}</p>
          </div>
          <div class="section-text-with-icons-type-1__button mt16 display-inline-flex">
            <a href="/products/bracket-fitment-service" class="link link-hover-span body3">
              <span>Book in</span>
              <svg class="theme-icon" xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.218579 0.221649C-0.0728598 0.517181 -0.0728598 0.996333 0.218579 1.29186L2.88921 4L0.21858 6.70814C-0.0728593 7.00367 -0.0728593 7.48282 0.21858 7.77835C0.510019 8.07388 0.982535 8.07388 1.27397 7.77835L5 4L1.27397 0.221649C0.982534 -0.073883 0.510018 -0.073883 0.218579 0.221649Z" fill="black"/>
              </svg>
            </a>
          </div>
        </div>
      </div>`;
  }

  // Builds a one-line, plain-English summary of how this variant fits with
  // the other bracket add-ons (indicator holders / static plate light /
  // locking shim), replacing what used to be three separate bullets.
  // Joins same-sentiment clauses with commas/"and"; switches to "but" the
  // first time the sentiment flips from positive to negative.
  function buildFitSummary(v) {
    const clauses = [];

    if (v.canMountStockIndicators || v.canMountAftermarketIndicators) {
      clauses.push({ text: 'has indicators holders built in', positive: true });
    } else if (v.noIndicatorMounts && v.canFitStatic === true) {
      clauses.push({ text: 'works well with our static indicator holders', positive: true });
    } else if (v.noIndicatorMounts && v.canFitStatic === false) {
      clauses.push({ text: 'works well with our moveable indicator holders', positive: true });
    } else if (v.noIndicatorMounts) {
      clauses.push({ text: "doesn't have indicator holders built in", positive: true });
    }

    if (v.plateLightBuiltIn) {
      clauses.push({ text: 'comes with a built-in plate light', positive: true });
    } else if (v.hasPlateLightHoles === true) {
      clauses.push({ text: 'can be used with our static plate light', positive: true });
    } else if (v.hasPlateLightHoles === false) {
      clauses.push({ text: "can't use our static plate light", positive: false });
    }

    clauses.push(v.badWithLockingShim
      ? { text: "doesn't work well with our Locking Shim", positive: false }
      : { text: 'is lockable with our Locking Shim', positive: true });

    if (!clauses.length) return '';

    let sentence = '';
    let usedUnfortunately = false;

    clauses.forEach((c, i) => {
      if (i === 0) {
        sentence += c.text;
        return;
      }
      const prev = clauses[i - 1];
      const isLast = i === clauses.length - 1;
      const flipped = c.positive !== prev.positive;

      if (flipped) {
        sentence += c.positive ? ', and ' : ', but ';
      } else {
        sentence += (isLast && clauses.length > 2) ? ' and ' : ', ';
      }

      if (!c.positive && !usedUnfortunately) {
        sentence += 'unfortunately ';
        usedUnfortunately = true;
      }

      sentence += c.text;
    });

    return `This bracket ${sentence}.`;
  }

  // ── Main render ───────────────────────────────────────────────────────────

  function renderVariant(variantId, { DATA, variantMap, target, relWrap, restockEl }) {
    const v = variantMap[variantId];
    if (!v || !target) return;

    const tags         = DATA.productTags || [];
    const isBracket    = tags.includes('bracket');
    const isRearLight  = tags.includes('rear-light');
    const multiVariant = DATA.variantCount > 1;
    const displayTitle = multiVariant ? `${v.title} variant` : DATA.productTitle;

    // Coming soon branch
    if (v.comingSoon) {
      target.innerHTML = renderComingSoon(v, DATA);
      kickFeather();
      // renderFitmentService(null);
      return;
    }

    const items = [];

    // Fit summary — replaces the separate plate-light / locking-shim /
    // indicator-holder bullets below with one consolidated sentence.
    if (isBracket) {
      const fitSummary = buildFitSummary(v);
      if (fitSummary) {
        items.push(`<li class="product__text"><span>${fitSummary}<br><small style="color:#999;font-style:italic;">Scroll down to find out more.</small></span></li>`);
      }
    }

    // Stock warnings
    if (v.inventoryManagement === 'shopify' && v.inventoryQty > 0 && v.inventoryQty < 10) {
      const stockMsg = v.inventoryQty === 1
        ? 'Stock: Almost gone — last one left!'
        : v.inventoryQty < 5
          ? 'Stock: Low stock — less than 5 left!'
          : "Stock: Less than 10 left — don't snooze";
      items.push(`<li class="product__text">${fi('alert-triangle')} <span style="color:#e68d40;font-weight:bold;">${stockMsg}</span></li>`);
    }

    // Plenty in stock
    if (v.inventoryManagement === 'shopify' && v.inventoryQty >= 10) {
      const stockText = DATA.productVendor === 'Printful'
        ? 'Available to order, made on demand.'
        : 'In stock. Available online and in store.';
      items.push(`<li class="product__text"><div class="live-light live-light--green"></div> <span style="color:#3ba65d;font-weight:bold;">${stockText}</span></li>`);
    }

    // Out of stock / restock estimate
    if (v.inventoryQty <= 0 && v.inventoryManagement === 'shopify') {
      const restockHtml = restockEl
        ? (restockEl.querySelector(`[data-variant-id="${v.id}"]`)?.innerHTML.trim() || '')
        : '';
      items.push(`<li class="product__text"><div class="live-light"></div> <span style="color:#e68d40;font-weight:bold;">${restockHtml}</span></li>`);
    }

    // Hidden: folded into the fit summary above. May bring back.
    // if (v.plateLightBuiltIn)
    //   items.push(`<li class="product__text">${fi('sun')} <span>...comes with a built-in plate light holder, so you don't need to buy an extra add-on. Just pick the right option below.</span></li>`);

    // ── Indicator mounts ──────────────────────────────────────────────────
    // Hidden: now duplicates the "Need indicator holders?" bracket block. May bring back.
    // if (v.canMountStockIndicators && v.canMountAftermarketIndicators) {
    //   items.push(`<li class="product__text">${fi('code')} <span>...has holes to mount both stock and universal / aftermarket indicators</span></li>`);
    // } else if (v.canMountAftermarketIndicators) {
    //   items.push(`<li class="product__text">${fi('alert-triangle')} <span>...only fits universal / aftermarket indicators — stock indicators will <strong>NOT</strong> fit</span></li>`);
    // } else if (v.canMountStockIndicators) {
    //   items.push(`<li class="product__text">${fi('code')} <span>...has holes to mount stock indicators</span></li>`);
    // }

    if (v.isReversible)
      items.push(`<li class="product__text">${fi('repeat')} <span>...is reversible. So it can also be used as a low/tucked mount</span></li>`);

    // if (v.noIndicatorMounts) {
    //   if (v.canFitStatic === true)
    //     items.push(`<li class="product__text">${fi('x-octagon')} <span>...does not have built-in indicator holders. Our <strong>static</strong> indicator holders will fit this bracket though. <a href="https://flipndip.co.uk/collections/indicator-holders" target="_blank">View indicator holders</a></span></li>`);
    //   else if (v.canFitStatic === false)
    //     items.push(`<li class="product__text">${fi('x-octagon')} <span>...does not have built-in indicator holders (also static indicator holders will <strong>NOT</strong> work with this bracket). You'll need to use moveable / alternative indicator holders. <a href="https://flipndip.co.uk/collections/indicator-holders" target="_blank">View indicator holders</a></span></li>`);
    //   else
    //     items.push(`<li class="product__text">${fi('x-octagon')} <span>...does not have indicator holders, so you will need to add <a href="https://flipndip.co.uk/collections/indicator-holders" target="_blank">indicator holders</a> separately, if you need them</span></li>`);
    // }

    // ── Plate light ───────────────────────────────────────────────────────
    // Hidden: folded into the fit summary above. May bring back.
    // Only fires when explicitly false — null/undefined = no message
    // if (v.hasPlateLightHoles === false) {
    //   items.push(`<li class="product__text">${fi('zap-off')} <span>...can NOT mount a static plate light. You'll need a <a href="https://flipndip.co.uk/collections/extras/products/number-plate-light" target="_blank">3M sticky plate light</a> instead</span></li>`);
    // }

    // Hidden: folded into the fit summary above. May bring back.
    // if (v.badWithLockingShim)
    //   items.push(`<li class="product__text">${fi('frown')} <span>...doesn't work well with the locking shim. It can't lock at a normal angle.</span></li>`);

    // if (v.hasInstallVideo)
    //   items.push(`<li class="product__text">${fi('youtube')} <span>...has an <a href="${v.hasInstallVideo}" target="_blank">install video here!</a></span></li>`);

    if (isRearLight) {
      items.push(`<li class="product__text product__text--rearlight">${fi('zap')} <span>Built-in indicators — check local regs before road use</span></li>`);
      if (!v.doesntHaveSequentialIndicating)
        items.push(`<li class="product__text product__text--rearlight"><div class="reveal">${fi('bar-chart')}</div> <span>Sequential/Sweeping indicators</span></li>`);
      if (!v.doesntHaveStrobeBrakeLight)
        items.push(`<li class="product__text product__text--rearlight"><div class="f1-brakes">${fi('loader')}</div> <span>F1 brake light - utilizes 3 quick red flashes when brakes are applied initially</span></li>`);
      items.push(`<li class="product__text product__text--rearlight">${fi('cloud')} <span>Smoked lens, for a stealthier look</span></li>`);
    }

    if (v.freeBullet1) items.push(`<li class="product__text product__text--free">${fi('arrow-right')} <span>${v.freeBullet1}</span></li>`);
    if (v.freeBullet2) items.push(`<li class="product__text product__text--free">${fi('arrow-right')} <span>${v.freeBullet2}</span></li>`);
    if (v.freeBullet3) items.push(`<li class="product__text product__text--free">${fi('arrow-right')} <span>${v.freeBullet3}</span></li>`);
    if (v.bulletHtml)  items.push(`<li class="product__text">${fi('arrow-right')} <span>${v.bulletHtml}</span></li>`);

    if (v.bulletFitmentTable?.length > 0) {
      const rows = v.bulletFitmentTable.map(item => `- ${item} <br>`).join('');
      items.push(`<li class="product__text">${fi('table')} This part fits: <br>${rows}</li>`);
    }

    if (v.supplierName) {
      const supplierLink = v.supplierUrl
        ? `<a href="${v.supplierUrl}" target="_blank" rel="noopener noreferrer">${v.supplierName}</a>`
        : v.supplierName;
      const logoHtml = v.supplierLogo
        ? `<img src="${v.supplierLogo}" alt="${v.supplierName}" loading="lazy" width="80" style="display:inline-block;vertical-align:middle;margin-left:6px;">`
        : '';
      items.push(`<li class="product__text">${fi('truck')} <span>Made by ${supplierLink}. Shipped by Flip N Dip. ${logoHtml}</span></li>`);
    }

    target.innerHTML = items.length > 0
      ? `<div class="product-bullets"><p>The ${displayTitle}:</p><ul class="product__text__container mt--first-child-0">${items.join('')}</ul></div>`
      : `<div class="product-bullets product-bullets-fallback"><p>${DATA.productDescription || ''}</p></div>`;

    kickFeather();

    // ── Fitment service block ─────────────────────────────────────────────
    // renderFitmentService(v.fittingDifficulty);
  }

  // ── Related products slot swap ────────────────────────────────────────────

  function swapRelatedProducts(variantId, relWrap) {
    if (!relWrap) return;
    relWrap.querySelectorAll('.variant-related-products__slot').forEach(slot => {
      slot.style.display = slot.dataset.variantId === String(variantId) ? '' : 'none';
    });
  }

  // ── Initialise one block instance ─────────────────────────────────────────

  function initBlock({ blockId, initialVariantId }) {
    const raw = document.getElementById(`variant-info-data--${blockId}`);
    if (!raw) return;

    const DATA       = JSON.parse(raw.textContent);
    const variantMap = {};
    DATA.variants.forEach(v => { variantMap[v.id] = v; });

    const ctx = {
      DATA,
      variantMap,
      target:    document.getElementById(`product-variant-info--${blockId}`),
      relWrap:   document.getElementById(`variant-related-products--${blockId}`),
      restockEl: document.getElementById(`variant-restock-data--${blockId}`),
    };

    function onChange(variantId) {
      renderVariant(variantId, ctx);
      swapRelatedProducts(variantId, ctx.relWrap);
    }

    // Dawn / modern themes
    document.addEventListener('variant:change', e => {
      if (e.detail?.variant) onChange(e.detail.variant.id);
    });

    // Fallback: watch the hidden variant input
    const variantInput = document.querySelector('input[name="id"][form]')
                      || document.querySelector('form[action="/cart/add"] input[name="id"]');
    if (variantInput) {
      new MutationObserver(() => {
        const id = parseInt(variantInput.value, 10);
        if (id) onChange(id);
      }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });

      variantInput.addEventListener('change', () => {
        const id = parseInt(variantInput.value, 10);
        if (id) onChange(id);
      });
    }

    // Initial render
    onChange(initialVariantId);
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────

  const existingQueue = window.FND_VariantInfo;
  if (Array.isArray(existingQueue)) {
    existingQueue.forEach(initBlock);
  }

  window.FND_VariantInfo = {
    push(config) { initBlock(config); }
  };

})();




(function () {
  'use strict';

  // Groups of vswap siblings are scoped per parent element, so blocks that
  // happen to reuse the same variant IDs (e.g. two separate vswap blocks on
  // one page) never match/hide each other's elements.
  function getSwapGroups() {
    const groups = new Map();
    document.querySelectorAll('.vswap').forEach(el => {
      const parent = el.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    return groups;
  }

  function swapByVariant(variantId) {
    const id = String(variantId);

    getSwapGroups().forEach(els => {
      const match = els.find(el => !el.classList.contains('vswap--default') && el.dataset.variantId === id);

      els.forEach(el => {
        const isDefault = el.classList.contains('vswap--default');
        if (match) {
          el.style.display = el === match ? '' : 'none';
        } else {
          el.style.display = isDefault ? '' : 'none';
        }
      });
    });
  }

  function getVariantId() {
    const input = document.querySelector('input[name="id"][form]')
               || document.querySelector('form[action="/cart/add"] input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  // Initial sync: show only the currently selected variant's content
  const initialVariantId = getVariantId();
  if (initialVariantId) {
    swapByVariant(initialVariantId);
  } else {
    // Fallback: show first vswap by default on load, scoped per container
    getSwapGroups().forEach(els => {
      const nonDefault = els.filter(el => !el.classList.contains('vswap--default'));
      nonDefault.forEach((el, i) => el.style.display = i === 0 ? '' : 'none');
    });
  }

  // Dawn / modern themes
  document.addEventListener('variant:change', e => {
    if (e.detail?.variant) swapByVariant(e.detail.variant.id);
  });

  // Fallback: watch the hidden input
  const input = document.querySelector('input[name="id"][form]')
             || document.querySelector('form[action="/cart/add"] input[name="id"]');
  if (input) {
    new MutationObserver(() => {
      const id = parseInt(input.value, 10);
      if (id) swapByVariant(id);
    }).observe(input, { attributes: true, attributeFilter: ['value'] });

    input.addEventListener('change', () => {
      const id = parseInt(input.value, 10);
      if (id) swapByVariant(id);
    });
  }

})();